import React from 'react';
import {AnalysisComponent} from './analysisComponent';
import {useTranslation} from 'react-i18next';
import {SearchPageType} from '../search/search-config';
import {useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';

export const AnalysisPage = React.memo(() => {
    const analysisConfig = useSelector((state) => state.config.analysis);
    const {push} = useHistory();
    if (!analysisConfig.enabled) {
        push('/');
    }
    const searchPageType = SearchPageType.BASIC;
    const {t} = useTranslation();

    return (
        <AnalysisComponent
            inputTitle={t('analysis.input.title')}
            resultsTitle={t('analysis.results.title')}
            searchPageType={searchPageType}
        />
    );
});
